import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

// Шапка страницы - один компонент на все разделы. До него у каждой страницы был свой h1
// с разными отступами, где-то с иконкой, где-то без, и подзаголовок то был, то нет.
// Ритм страницы должен быть один: человек не должен заново искать глазами, где он находится.
//
// description - одна строка про то, ЗАЧЕМ сюда заходят, словами владельца. Не описание
// технической реализации раздела.

export function PageHeader({
  icon,
  title,
  description,
  actions,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Кнопки и фильтры справа от заголовка. */
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h1 className="flex items-center gap-2 text-xl font-semibold">
          {icon ? <span className="text-accent-fg">{icon}</span> : null}
          {title}
        </h1>
        {description ? (
          <p className="mt-1 max-w-prose text-sm leading-snug text-muted">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
